import { create } from "zustand";

// make the store persist across refreshes
export const useIsOffline = create<{
  isOffline: boolean;
  setIsOffline: (isOffline: boolean) => void;
}>(set => ({
  isOffline: false,
  setIsOffline: isOffline => set({ isOffline }),
}));
